import React, { useEffect, useState } from 'react';
import { FaFacebook, FaInstagram, FaPinterest, FaTwitter, FaWhatsapp, FaYoutube } from 'react-icons/fa';
import { db } from './Firebase';
import { RiGlobalLine } from "react-icons/ri";
import { Link } from 'react-router-dom';


export default function Footer() {

    const [socialmedia, setsocialmedia] = useState("")

    function fetchData() {
        db.collection("socialmedia").onSnapshot((snapshot) => {
            if (!snapshot.empty) {
                const firstDoc = snapshot.docs[0].data();
                setsocialmedia(firstDoc);
            }
        });
    }
    useEffect(() => {
        fetchData();
    }, [])

    const [businessinfo, setBusinessInfo] = useState("")

    function fetchDataa() {
        db.collection("businessinfo").onSnapshot((snapshot) => {
            if (!snapshot.empty) {
                const firstDoc = snapshot.docs[0].data();
                setBusinessInfo(firstDoc);
            }
        });
    }
    useEffect(() => {
        fetchDataa();
    }, [])

    return (
        <footer className="footer-section text-white pt-5">
            <div className="container">
                <div className="row g-4">
                    <div className="col-lg-3 col-md-3 col-sm-6">
                        <h5 className="mb-3">{businessinfo.businessname}</h5>
                        <p className="text-light">Timeless menswear designed for the modern man. <br />Craftsmanship. Comfort. Confidence.</p>
                    </div>

                    <div className="col-6 col-lg-3 col-md-3 col-sm-6">
                        <h6 className="text-uppercase mb-3">Quick Links</h6>
                        <ul className="list-unstyled">
                            <li><Link to="/" className="footer-link text-light text-decoration-none">Home</Link></li>
                            <li><Link to="/About" className="footer-link text-light text-decoration-none">About Us</Link></li>
                            <li><Link to="/Products" className="footer-link text-light text-decoration-none">Our Products</Link></li>
                            <li><Link to="/Contact" className="footer-link text-light text-decoration-none">Support</Link></li>
                            <li><Link to="/Distributor" className="footer-link text-light text-decoration-none">Become a Distributor</Link></li>
                        </ul>
                    </div>

                    <div className="col-6 col-lg-3 col-sm-6">
                        <h6 className="text-uppercase mb-3">Customer Care</h6>
                        <ul className="list-unstyled">
                            <li><Link to="/Contact" className="footer-link text-light text-decoration-none">Contact Us</Link></li>
                            <li><a href="#" className="footer-link text-light text-decoration-none">FAQs</a></li>
                            <li><a href="#" className="footer-link text-light text-decoration-none">Sizes Available</a></li>
                        </ul>
                    </div>

                    <div className="col-lg-3 col-sm-6">
                        <h6 className="text-uppercase mb-3">Follow Us</h6>
                        <div className="d-flex gap-3">
                            <a href={socialmedia.Instagram} className="social-icon text-white"><FaInstagram /></a>
                            <a href="" onClick={() =>
                                window.open(
                                    "https://wa.me/919517909090?text=Hi%2C%20I%20am%20interested%20in%20your%20products.%20Can%20you%20help%20me%3F",
                                    "_blank"
                                )
                            } className="social-icon text-white"><FaWhatsapp /></a>
                            <a href="#" className="social-icon text-white"><RiGlobalLine /></a>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 border-top w-100 pt-3">
                    <p className="text-light text-decoration-none small mb-3">© {new Date().getFullYear()} SOCIALBUZDYNAMICS. All rights reserved.</p>
                    <div className="d-flex gap-4">
                        <a href="#" className="footer-link text-light text-decoration-none small mb-3">Privacy Policy</a>
                        <a href="#" className="footer-link text-light text-decoration-none small mb-3">Terms & Conditions</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};